// extracted by mini-css-extract-plugin
export default {"container":"LineSpinner_container__6FH31","loading":"LineSpinner_loading__csjfm"};